import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import * as zenscroll from 'zenscroll';

import Onboarding from './Onboarding';
import ProductsNew from './ProductsNew';
import Allergies from './Allergies';
import SkinConcerns from './SkinConcerns';
import BrandsYouLike from './BrandsYouLike';
import Picture from './Picture';
import { ChatContainerWrapper } from './OnboardingStyles';
import HelloavaText from './helloavaText';
import RegistrationPage from '../onboardingAA/RegistrationPage';
import ProblemResults from '../onboardingAA/ProblemResults';
import SkinQuizTransition from '../onboardingAA/SkinQuizTransition';
import StepsNewQuiz from '../onboardingAA/StepsNewQuiz';
import NewName from '../onboardingAA/Name';
import Restart from '../onboardingAA/Restart';
import SelfieModeIsSelect from '../onboardingAA/SelfieModeIsSelect';

// import HorizBarWithTooltip from '../../components/onboarding/HorizBarWithTooltip';
import Api from '../../utils/api';
import {buttonsContentManage} from '../../utils/util';

// import '../../components/onboarding/SelectBubble.css';


class OnboardingContainer extends Component {
    constructor(props) {
        super(props);

        this.funStateQuiz = this.funStateQuiz.bind(this);

        this.state = {
            stage: 0,
            stepsSum:0,
            width: document.documentElement.clientWidth,
            redirectToHome: false,
            whyHrefButtons: [
                {label:'I’m starting from scratch',value:1},
                {label:'My current routine just isn’t working',value:2},
                {label:'I need to *spice* up my current routine',value:3},
                {label:'I want to see if I am using the right products',value:4},
                {label:'I want to have some expert advice',value:5},
            ],
            ageDataArray:[
                { value: '1', label: "under 18"},
                { value: '2', label: "19-25"},
                { value: '3', label: "26-35"},
                { value: '4', label: "36-50"},
                { value: '5', label: "50+"}
            ],
            sexDataArray:[
                { value: '1', label: "She/Her" },
                { value: '2', label: "He/Him"},
                { value: '4', label: "They/Them"},
                { value: '3', label: "Prefer not to disclose"}
            ],
            breastfeedingDataArray:[
                { value: '1', label: "Yes",},
                { value: '2', label: "No",},
            ],
            ethnicityDataArray:[
                { value: '1', label: "Hispanic or Latino"},
                { value: '2', label: "American Indian or Alaska Native"},
                { value: '3', label: "Asian"},
                { value: '4', label: "Black or African American"},
                { value: '5', label: "Native Hawaiian or Other Pacific Islander"},
                { value: '6', label: "Caucasian"},
                { value: '8', label: "Multiracial" },
                { value: '7', label: "Prefer not to disclose"},
            ],
            budgetDataArray:[
                { value: '2', label: "<$50 - Most Affordable 🙏"},
                { value: '3', label: "<$75 - Most Effective 🙌"},
                { value: '4', label: "I’m open 😊"}
            ],


            lightning1DataArray:[
                { value: '1', label: "Dry or flaky" },
                { value: '2', label: "Somewhat dry"},
                { value: '3', label: "Well hydrated"},
                { value: '4', label: "Shiny or oily"}
            ],
            lightning2DataArray:[
                { value: '1', label: "Always"},
                { value: '2', label: "Sometimes"},
                { value: '3', label: "Rarely"},
                { value: '4', label: "Never"}
            ],
            lightning3DataArray:[
                { value: '1', label: "Dry or flaky"},
                { value: '2', label: "Well hydrated"},
                { value: '3', label: "Slightly shiny"},
                { value: '4', label: "Oliy"}
            ],
            lightning4DataArray:[
                { value: '1', label: "Not at all"},
                { value: '2', label: "Occasionally"},
                { value: '3', label: "All the time"},
                { value: '4', label: "Unsure"}
            ],
            lightning5DataArray:[
                { value: '1', label: "Never"},
                { value: '2', label: "Occasionally"},
                { value: '3', label: "Frequently"},
                { value: '4', label: "Always"}
            ],
            lightning6DataArray:[
                { value: '1', label: "Never"},
                { value: '2', label: "Rarely"},
                { value: '3', label: "Sometimes"},
                { value: '4', label: "Always"}
            ],
            lightning7DataArray:[
                { value: '1', label: "Never or I don't have pimples "},
                { value: '2', label: "Sometimes"},
                { value: '3', label: "Often"},
                { value: '4', label: "Always"}
            ],
            lightning8DataArray:[
                { value: '1', label: "Becomes red or sunburned but does not get darker "},
                { value: '2', label: "Becomes red, but then gets darker"},
                { value: '3', label: "Becomes much darker"},
                { value: '4', label: "Unchanged or I already have dark skin"}
            ],
            lightning9DataArray:[
                { value: '1', label: "Not really"},
                { value: '2', label: "Yes, in the past but not currently "},
                { value: '3', label: "Yes, currently"},
                { value: '4', label: "Yes, currently and it is noticeable from a distance"}
            ],
            lightning10DataArray:[
                { value: '1', label: "Rarely (less than 10 days a year)"},
                { value: '2', label: "Sometimes (more than 10 days a year)"},
                { value: '3', label: "All the time (almost everyday)"},
            ],
            lightning11DataArray:[
                { value: '1', label: "Minimal"},
                { value: '2', label: "Moderate"},
                { value: '3', label: "High"},
                { value: '4', label: "I don't know"}
            ],
            lightning12DataArray:[
                { value: '1', label: "Never, not even when squinting, frowning or laughing"},
                { value: '2', label: "Yes, I have some fine lines only when I squint, frown, or laugh"},
                { value: '3', label: " Yes, a few wrinkles when squinting or frowning and fine lines at rest"},
                { value: '4', label: "Yes, I have some wrinkles at rest"}
            ],
            regionDataArray:[
                { value: '1', label: "Yes"},
                { value: '2', label: "No"},
            ],
            isInSkinQuizView: localStorage.getItem("auth_token") ?  true : false,
            isSkinQuizStart:false,
            stepsTitel:'Skin quiz',
        };

        this.updateStage = this.updateStage.bind(this);
        this.updateStepsSum = this.updateStepsSum.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
    }

    // componentWillMount() {
    //     if (util.isMobile(navigator.userAgent) && process.env.REACT_APP_ENV === 'prod') {
    //         window.location.href = "https://sendbottles.com/r/2194?t=Hi%20Ava";
    //         this.props.history.push("/");
    //     }
    // }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this), false);
        if (this.props.location.search.includes("gift")) {
            localStorage.setItem("gift_user", true);
        }

        if(localStorage.getItem("user_has_skin_profile") == 'true'){
            let url = buttonsContentManage();
            this.props.history.push(url);
        }

        try {
            let doneQuizStepId = localStorage.getItem("doneQuizStepId");
            if(doneQuizStepId){
                this.funStateQuiz();
            }
           
        } catch (error) {
            
        }
    }
    

    componentWillUnmount() {
        // window.removeEventListener('resize', this.handleMediaQueries(this), false);
    }

    handleMediaQueries() {
        this.setState({
            width: document.documentElement.clientWidth
        });
    }

    eventTrackingStageProgress(step) {
        if ((process.env.REACT_APP_ENV === 'prod') && !localStorage.getItem("auth_token")) {
            if (step === 'userName') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 2 - What's Your Name?",
                    value: 1
                });
            } else if (step === 3) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 3 - Do you live in the US?",
                    value: 1
                });
            } else if (step === 4) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 4 - How old are you?",
                    value: 1
                });
            } else if (step === 'age') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 5 - Are you Male or Female?",
                    value: 1
                });
            } else if (step === 6) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 6 - What is Your Ethnicity?",
                    value: 1
                });
            } else if (step === 7) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 7 - What are your primary skin concerns?",
                    value: 1
                });
            } else if (step === 8) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8 - What products are you interested in exploring today?",
                    value: 1
                });
            } else if (step === 24) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8-2 - Budget Question",
                    value: 1
                });
            } else if (step === 9) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 9 - Are you allergic to any of the below ingredients?",
                    value: 1
                });
            } else if (step === 10) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 10 - Could you take a selfie?",
                    value: 1
                });
            } else if (step === 11) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 11 - Q1",
                    value: 1
                });
            } else if (step === 12) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 12 - Q2",
                    value: 1
                });
            } else if (step === 13) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 13 - Q3",
                    value: 1
                });
            } else if (step === 14) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 14 - Q4",
                    value: 1
                });
            } else if (step === 15) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 15 - Q5",
                    value: 1
                });
            } else if (step === 16) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 16 - Q6",
                    value: 1
                });
            } else if (step === 17) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 17 - Q7",
                    value: 1
                });
            } else if (step === 18) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 18 - Q8",
                    value: 1
                });
            } else if (step === 19) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 19 - Q9",
                    value: 1
                });
            } else if (step === 20) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 20 - Q10",
                    value: 1
                });
            } else if (step === 21) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 21 - Q11",
                    value: 1
                });
            } else if (step === 22) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 22 - Q12",
                    value: 1
                });
            } else if (step === 23) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 23 - Create Account",
                    value: 1
                });
            }
        }
    }

    updateStage(stage,stepsSum,stepsTitel) {
        this.setState({ stage: stage });
        if(stepsSum){
            this.setState({stepsSum:stepsSum});
        }
        if(stepsTitel){
            this.setState({stepsTitel:stepsTitel});
        }
    }

    updateStepsSum(stepsSum) {
        this.setState({ stepsSum: stepsSum });
    }

    redirectToHome() {
        this.setState({redirectToHome: true});
    }

    funStateQuiz(){
        this.setState({isSkinQuizStart:true});
    }

    render() {
        
        const startOfStepsSkinQuiz_name = [
            {
                id: 'Q1',
                message: "First thing’s first, what’s your name?",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress('userName');
                    return 'Q1-1';
                }
            },
            {
                id: 'Q1-1',
                asMessage: true,
                waitAction: true,
                replace:true,
                component: <NewName skinQuizType={'SQ_userName'} fun_updateStage={this.updateStage} stage={1} stageSum={24} />,
                trigger: ({ value, steps }) => {
                    return 'Q1-result';
                }
            },

            {
                id: 'Q1-result',
                delay:0,
                component:<ProblemResults helloTextStorageKey = {'SQ_firstname'}></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q1-2';
                }
            },

            
            {
                id: 'Q1-2',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={1} stageSum={24} showText="Nice to virtually meet you, " helloTextStorageKey = {'SQ_firstname'} /> ),
                trigger: ({ value, steps }) => {
                    return 'Q2-restart';
                }
            },
            {
                id: 'Q2-restart',
                delay:0,
                component: <Restart/>,
                trigger:  ({ value, steps }) => {
                    return 'Q2';
                }
            },

            {
                id: 'Q2',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={2} stageSum={24} skinQuizType={'SQ_age'} showText="How old are you?" buttonDataArrar={this.state.ageDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q2-result';
                }
            },
            {
                id: 'Q2-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q3';
                }
            },

            {
                id: 'Q3',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={3} stageSum={24} skinQuizType={'SQ_gender'} showText="Thanks! And what gender pronouns do you identify with?" buttonDataArrar={this.state.sexDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q3-result';
                }
            },
            {
                id: 'Q3-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    if(localStorage.getItem("SQ_gender") == "1" ){
                        return 'Q4';
                    }else{
                        return 'Q5-restart';
                    }
                }
            },


            {
                id: 'Q4',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={4} stageSum={24} skinQuizType={'SQ_pregnant'} showText="Are you currently pregnant or breastfeeding?" buttonDataArrar={this.state.breastfeedingDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q4-result';
                }
            },
            {
                id: 'Q4-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q5';
                }
            },

            {
                id: 'Q5-restart',
                delay:0,
                component: <Restart/>,
                trigger: ({ value, steps }) => {
                    try {
                        localStorage.setItem("doneQuizStepId",'Q5-restart');
                    } catch (error) {
                        console.error(error);
                    }
                    return 'Q5'
                }
            },


            {
                id: 'Q5',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={5} stageSum={24} skinQuizType={'SQ_ethnicity'} isAllSelect={false} showText="Which ethnicity do you identify with?" buttonDataArrar={this.state.ethnicityDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q5-result';
                }
            },
            {
                id: 'Q5-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q6';
                }
            },
        ]

        const startOfStepsSkinQuiz_skinConcern = [
            {
                id: 'Q6',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText htmlDom={'<div id="skinConcerns-postion-top"></div>'} showText="Thank you so much! Now, let’s get to your skin so that we can put together your recommendations and get you scheduled for further analysis with one of our licensed estheticians."/> ),
                // message: "Thank you so much! Now, let’s get to your skin so that we can put together your recommendations and get you scheduled for further analysis with one of our licensed estheticians.",
                trigger: ({ value, steps }) => {
                    return 'Q6-restart';
                }
            },

            {
                id: 'Q6-restart',
                delay:0,
                component: <Restart/>,
                trigger: 'Q7',
            },

            {
                id: 'Q7',
                asMessage: true,
                waitAction: true,
                delay:2000,
                component: <SkinConcerns fun_updateStage = {this.updateStage} stage={6} stageSum={24} skinQuizType={'SQ_concerns'} showText="First thing’s first, what are your skin concern(s) 🧐 ?"/>,
                trigger: ({ value, steps }) => {
                    return 'Q7-results';
                }
            },

            

            {
                id: 'Q7-results',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q8';
                }
            },


            {
                id: 'Q8',
                delay:2000,
                message: "We can definitely help with that.",
                trigger: ({ value, steps }) => {
                    return 'Q8-restart';
                }
            },
            {
                id: 'Q8-restart',
                delay:0,
                component: <Restart/>,
                trigger: 'Q8-1',
            },
            {
                id: 'Q8-1',
                asMessage: true,
                waitAction: true,
                delay:2000,
                component: <Allergies fun_updateStage = {this.updateStage} stage={7} stageSum={24} skinQuizType={'SQ_allergys'} showText="Are you allergic or ever had a bad reaction to any of the below ingredients?"/>,
                trigger: ({ value, steps }) => {
                    return 'Q8-results';
                }
            },
            {
                id: 'Q8-results',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: 'Q9',
            },


            {
                id: 'Q9',
                message: "Got it.",
                delay:2000,
                trigger: ({ value, steps }) => {
                    return 'Q9-1';
                }
            },
            {
                id: 'Q9-1',
                asMessage: true,
                waitAction: true,
                delay:2000,
                component: <ProductsNew fun_updateStage = {this.updateStage} stage={8} stageSum={24} skinQuizType={'SQ_productsNew'} showText="What skincare routine do you feel you need the most? If you’re not sure, we can help you decide later on. Just select “I am not sure.”"/>,
                trigger: ({ value, steps }) => {
                    return 'Q9-results';
                }
            },
            {
                id: 'Q9-results',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Q10',
            },

            {
                id: 'Q10',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText fun_updateStage={this.updateStage} stage={9} stageSum={24}  skinQuizType={'SQ_budget'} isAllSelect={false} showText="Sounds great. What’s your ideal budget for each product?" buttonDataArrar={this.state.budgetDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q10-result';
                }
            },
            {
                id: 'Q10-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Q11',
            },


            
            {
                id: 'Q11',
                asMessage: true,
                waitAction: true,
                component: <BrandsYouLike fun_updateStage={this.updateStage} stage={10} stageSum={24} skinQuizType={'SQ_brand'} showText="Which of the brands below speak to you?" /> ,
                delay:2000,
                trigger: ({ value, steps }) => {
                    return 'Q11-result';
                }
            },
            {
                id: 'Q11-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: 'Q12',
            },
            
            // 是否上传照片，这个值不需要上传服务器 
            {
                id: 'Q12',
                delay:2000,
                asMessage: true,
                component:(<SelfieModeIsSelect fun_updateStage={this.updateStage} stage={11} stageSum={24} showText="Next, send us a selfie📸 so that we can accurately analyze your skin with our smart algorithm! (Your selfie is for our eyes only, it will be kept confidential)."/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q12-results';
                    
                }
            },

            {
                id: 'Q12-results',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    if(value == 1){
                        return 'Q12-1';
                    }else{
                        return 'Q12-1-restart';
                    }
                    
                }
            },


            {
                id: 'Q12-1',
                delay:2000,
                component:(<Picture fun_updateStage={this.updateStage} stage={12} stageSum={24} skinQuizType={'SQ_picture'} showText="" answerWidthCheck={this.state.width} />),
                asMessage: true,
                waitAction: true,
                trigger:({ value, steps }) => {
                    return 'Q12-1-restart'
                },
            },

            {
                id: 'Q12-1-restart',
                delay:0,
                component: <Restart/>,
                trigger: ({ value, steps }) => {
                    try {
                        localStorage.setItem("doneQuizStepId",'Q12-1-restart');
                    } catch (error) {
                        console.error(error);
                    }
                    return 'Q13';
                }
            },


            {
                id: 'Q13',
                delay:2000,
                message: "Okay great, now let’s do a lightning⚡️ round! This will help us hone in on the best products for your skin type.",
                trigger: ({ value, steps }) => {
                    return 'Q13-restart';
                }
            },

            {
                id: 'Q13-restart',
                delay:0,
                component: <Restart/>,
                trigger: 'Lightning1',
            },

            

            {
                id: 'Lightning1',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-1'} isAllSelect={false} showText="Finish the sentence: On average, your face (excluding T-zone area) appears 👀 " buttonDataArrar={this.state.lightning1DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning1-result';
                }
            },
            {
                id: 'Lightning1-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning3',
            },

            // {
            //     id: 'Lightning2',
            //     delay:2000,
            //     asMessage: true,
            //     component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-2'} isAllSelect={false} showText="Before applying moisturizer, your face (excluding T-zone area) feel dry 🌵" buttonDataArrar={this.state.lightning2DataArray}/> ),
            //     waitAction: true,
            //     trigger: ({ value, steps }) => {
            //         return 'Lightning2-result';
            //     }
            // },
            // {
            //     id: 'Lightning2-result',
            //     component:<ProblemResults></ProblemResults>,
            //     trigger:'Lightning3',
            // },

            {
                id: 'Lightning3',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-3'} isAllSelect={false} showText="Several hours after applying moisturizer 💦 your T-zone area appears" buttonDataArrar={this.state.lightning3DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning3-result';
                }
            },
            {
                id: 'Lightning3-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning4',
            },

            {
                id: 'Lightning4',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-4'} isAllSelect={false} showText="Certain skincare ingredients and/or moisturizers, makeup, and cleansers cause your face to break out, itch, or burn 😖" buttonDataArrar={this.state.lightning4DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning4-result';
                }
            },
            {
                id: 'Lightning4-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning5',
            },

            {
                id: 'Lightning5',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-5'} isAllSelect={false} showText="Your face gets red 🥵 after moderate exercise, strong emotions like anger, or eating spicy foods" buttonDataArrar={this.state.lightning5DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning5-result';
                }
            },
            {
                id: 'Lightning5-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning6',
            },

            {
                id: 'Lightning6',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-6'} isAllSelect={false} showText="You tend to have facial acne/pimples🚨" buttonDataArrar={this.state.lightning6DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning6-result';
                }
            },
            {
                id: 'Lightning6-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning7',
            },

            {
                id: 'Lightning7',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-7'} isAllSelect={false} showText="You will develop red spots or discoloration 💔 after pimples" buttonDataArrar={this.state.lightning7DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning7-result';
                }
            },
            {
                id: 'Lightning7-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning8',
            },

            {
                id: 'Lightning8',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-8'} isAllSelect={false} showText="After spending hours in the sun ☀️ your skin" buttonDataArrar={this.state.lightning8DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning8-result';
                }
            },
            {
                id: 'Lightning8-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning9',
            },

            {
                id: 'Lightning9',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-9'} isAllSelect={false} showText="You have a history of hyperpigmentation 🙃 (a harmless condition where patches of skin become darker in color such as sun spots)" buttonDataArrar={this.state.lightning9DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning9-result';
                }
            },
            {
                id: 'Lightning9-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning10',
            },

            {
                id: 'Lightning10',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-10'} isAllSelect={false} showText="How often do you go out in the sun without sunscreen? 😎" buttonDataArrar={this.state.lightning10DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning10-result';
                }
            },
            {
                id: 'Lightning10-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning11',
            },

            {
                id: 'Lightning11',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-11'} isAllSelect={false} showText="The air pollution 🏙☁  where you live is" buttonDataArrar={this.state.lightning11DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning11-result';
                }
            },
            {
                id: 'Lightning11-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger:'Lightning12',
            },

            {
                id: 'Lightning12',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText updateStage={this.updateStage} skinQuizType={'SQ_A8-12'} isAllSelect={false} showText="Last one! You notice facial wrinkles 🔎" buttonDataArrar={this.state.lightning12DataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Lightning12-result';
                }
            },
            {
                id: 'Lightning12-result',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                end:true,
            },
        ]

        const startOfStepsNotRegister = [
            {
                id: 'Q1',
                message: "Hello! 👋   We are so excited to get you started on your skincare journey with HelloAva. ",
                trigger: ({ value, steps }) => {
                    return 'Q1-1';
                }
            },

            {
                id: 'Q1-1',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText skinQuizType ={'SQ_signupPurposeId'} isAllSelect={true} showText="Tell us a bit about how we can help you." buttonDataArrar={this.state.whyHrefButtons}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    return 'Q1-2';
                }
            },

            {
                id: 'Q1-2',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q1-3';
                }
            },
            {
                id: 'Q1-3',
                delay:2000,
                message: "We hear you! We can help for sure. ",
                trigger: ({ value, steps }) => {
                    return 'Q1-3-restart';
                }
            },

            {
                id: 'Q1-3-restart',
                delay:0,
                component: <Restart/>,
                trigger: 'region-quiz',
            },         



            {
                id: 'region-quiz',
                delay:2000,
                asMessage: true,
                component:(<HelloavaText skinQuizType={'SQ_region'} isAllSelect={false} showText="To make sure we cover your region, do you live in either the US, Canada or UK?" buttonDataArrar={this.state.regionDataArray}/> ),
                waitAction: true,
                trigger: ({ value, steps }) => {
                    if(value['value'] == 1){
                        return 'region-results';
                    }else{
                        return 'region-end';
                    }
                }
            },

            {
                id: 'region-results',
                delay:0,
                component:<ProblemResults></ProblemResults>,
                trigger: ({ value, steps }) => {
                    return 'Q2';
                }
            },

            {
                id: 'region-end',
                message: 'Ah, we are so sorry but we are not in your region yet 🥺. But don’t worry, you will be the first to know if we expand internationally! 😇 Apologies!',
                end: true
            },

            {
                id: 'Q2',
                delay:2000,
                message: "Yay! HelloAva is in your region.",
                trigger: ({ value, steps }) => {
                    return 'Q2-1';
                }
            },
            {
                id: 'Q2-1',
                delay:2000,
                message: "Now, create your account to start your skin journey.",
                trigger: ({ value, steps }) => {
                    return 'Q2-2';
                }
            },
            {
                id: 'Q2-2',
                delay:2000,
                asMessage:true,
                replace:true,
                waitAction: true,
                component:(<RegistrationPage skinQuizType={'SQ_createAccount'}/> ),
                trigger: ({ value, steps }) => {
                    this.setState({ isInSkinQuizView:true });                    
                    return 'Q2-3';
                }
            },

            {
                id: 'Q2-3',
                delay:2000,
                message: "成功了",
                end: true,
            },
        ]


        let startOfStepsSkinQuiz = [];
        startOfStepsSkinQuiz = startOfStepsSkinQuiz_name.concat(startOfStepsSkinQuiz_skinConcern);
        let doneQuizStepId = localStorage.getItem("doneQuizStepId");
        let arrayIndex = 0;
        if(doneQuizStepId){
            try {
                startOfStepsSkinQuiz.forEach((element,index) => {
                    if(element['id'] == doneQuizStepId){
                        arrayIndex = index;
                        throw 'End cycle';
                    }
                });
            } catch (error) {}
            if(arrayIndex>0){
                startOfStepsSkinQuiz = startOfStepsSkinQuiz.slice(arrayIndex+1);
            }
        }

        return (
					<ChatContainerWrapper className={this.state.isInSkinQuizView ? "skinQuiz-wrapper":null} id="onboarding-container-wrapper" /*style={ this.state.width > 813 ? quizStyle : quizStyleMobile }*/>
						<Helmet>
							<title>HelloAva Skincare Assessment Quiz</title>
							<meta name="description" content="Answer Ava’s questions in our skincare quiz to unlock your best skin care products and routine." />
						</Helmet>

                        {
                            !this.state.isInSkinQuizView ?  <Onboarding style={{paddingTop:0}}  steps={ startOfStepsNotRegister }/> :
                            <div className="skinQuiz-wrapper-view" style={this.state.isInSkinQuizView ? {display:'block'}:{display:'none'}}>
                                {/* skin quiz 头部进度条 */}
                                <StepsNewQuiz stepsTitel = {this.state.stepsTitel} step={this.state.stage} stepsSum={this.state.stepsSum}></StepsNewQuiz>
                               
                                {/* skin quiz 欢迎页 */}
                                {
                                    this.state.isSkinQuizStart ?  <Onboarding isEndFunction={true} style={{paddingTop:'47px'}} steps={ startOfStepsSkinQuiz }/>
                                    : <SkinQuizTransition funStateQuiz={this.funStateQuiz}></SkinQuizTransition>
                                }
                            </div>
                        }

					</ChatContainerWrapper>

        );
    }
}




export default withRouter(connect()(OnboardingContainer))



// WEBPACK FOOTER //
// ./src/views/onboarding/OnboardingContainer.js